import React from "react";
import { Icon } from "semantic-ui-react";
import { instantFromApi } from "../utils/dateTime";
import { Instant } from "js-joda/dist/js-joda";

function getTickRunningMinutes(bi) {
  // Was sometimes throwing "Unable to obtain Instant from TemporalAccessor" when used instantFromApi(bi.startedAt).until(Instant.now(), ChronoUnit.MINUTES)
  return bi.startedAt && !bi.finishedAt
    ? Math.ceil((Instant.now().epochSecond() - instantFromApi(bi.startedAt).epochSecond()) / 60)
    : 0;
}

export default ({ botInstance }) => {
  const runningMinutes = getTickRunningMinutes(botInstance);
  return runningMinutes > 5 && <Icon name="hourglass half" color="red" title={`Tick running ${runningMinutes}min.`} />;
};



// WEBPACK FOOTER //
// ./src/bot/HangingIcon.js